import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Globe, MapPin } from "lucide-react";

const REGIONS = ["North America", "South America", "Europe", "UK & Ireland", "Africa", "Middle East", "Asia", "Oceania"];

export default function RightsMap() {
  const [health, setHealth] = useState(null);
  useEffect(() => { api.get("/catalog/health").then(({ data }) => setHealth(data)).catch(() => {}); }, []);
  const territories = health?.territories || [];
  const worldwide = territories.includes("Worldwide") || territories.length >= 10;

  return (
    <div data-testid="rights-map-page">
      <div className="mb-8"><h4 className="text-xs font-semibold tracking-[0.25em] uppercase text-zinc-500 mb-2">Global Rights</h4><h1 className="font-heading text-4xl font-black tracking-tighter uppercase">Rights Map</h1></div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <div className="bg-card border border-border rounded-lg p-6"><div className="flex items-center gap-2 mb-2"><Globe className="h-5 w-5 text-primary" /><span className={`font-mono text-2xl font-semibold ${worldwide ? "text-primary" : "text-amber-400"}`}>{health?.rights_coverage || "—"}</span></div><div className="text-xs uppercase tracking-widest text-zinc-500">Coverage Status</div></div>
        <div className="bg-card border border-border rounded-lg p-6"><div className="font-mono text-3xl font-semibold">{territories.length}</div><div className="text-xs uppercase tracking-widest text-zinc-500 mt-1">Territories Registered</div></div>
        <div className="bg-card border border-border rounded-lg p-6"><div className="font-mono text-3xl font-semibold">{health?.total_songs || 0}</div><div className="text-xs uppercase tracking-widest text-zinc-500 mt-1">Works Covered</div></div>
      </div>

      <div className="bg-card border border-border rounded-lg p-6 sm:p-8">
        <h3 className="font-heading text-xl font-semibold mb-6">Territory Coverage</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {REGIONS.map((region) => {
            const active = worldwide || territories.some((t) => region.toLowerCase().includes(t.toLowerCase()) || t.toLowerCase().includes(region.split(" ")[0].toLowerCase()));
            return (
              <div key={region} data-testid={`region-${region}`} className={`rounded-lg border p-5 transition-colors ${active ? "border-primary/40 bg-primary/10" : "border-border bg-secondary/40"}`}>
                <MapPin className={`h-5 w-5 mb-3 ${active ? "text-primary" : "text-zinc-600"}`} />
                <div className="font-semibold text-sm">{region}</div>
                <div className={`text-xs mt-1 ${active ? "text-primary" : "text-zinc-500"}`}>{active ? "Covered" : "No coverage"}</div>
              </div>
            );
          })}
        </div>
        {territories.length > 0 && <div className="mt-6 text-sm text-zinc-400">Registered from deals: {territories.join(", ")}</div>}
        {territories.length === 0 && <p className="mt-6 text-sm text-zinc-500">Add deals with territories to build your rights map.</p>}
      </div>
    </div>
  );
}
